exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".categorise-dialog {\n  min-width: 300px; }\n\n.categorise-dialog > div {\n  width: 100%; }\n  .categorise-dialog > div label {\n    color: #777777 !important; }\n  .categorise-dialog > div::after {\n    border-bottom: 2px solid #777777 !important; }\n\n.tags-selector .select-category {\n  margin-bottom: 10px; }\n  .tags-selector .select-category::after {\n    border-bottom: 2px solid #777777 !important; }\n\n.tags-selector::after {\n  border-bottom: 2px solid #777777 !important; }\n\n@media only screen and (max-width: 500px) {\n  .categorise-dialog {\n    min-width: auto; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/products/list/addCategoryTag/index.scss
// module id = 1282
// module chunks = 0